import { gql } from '@apollo/client'

const UPSERT_GOAL_UPDATE = gql`
  mutation upsertGoalUpdate(
    $goalUpdateInfo: GoalTextUpdateInput!
    $nonprofitOrgId: Int!
  ) {
    upsertGoalUpdate(
      goalUpdateInfo: $goalUpdateInfo
      nonprofitOrgId: $nonprofitOrgId
    ) {
      id
      goalId
      taskId
      taskTitle
      description
      reportedAt
      updatedAt
      lastUpdatedUser {
        id
        firstName
        lastName
      }
    }
  }
`

export default UPSERT_GOAL_UPDATE
